export default {
  tgInviteLinkCpa: '',
  minAppURL: '',
  tgBtn: true,
}
